import {
  GET_SEARCH_REQUEST,
  GET_SEARCH_SUCCESS,
  GET_SEARCH_ERROR,
  SET_ADDRESS_QUERY,
  SET_REFINEMENTS,
  CLEAR_REFINEMENTS,
  GET_TAGS_REQUEST,
  GET_TAGS_SUCCESS,
  GET_TAGS_ERROR
} from "../actions/searchActions";

const initialState = {
  loading: false,
  locationEvents: null,
  error: false,
  searchComponent: {
    query: "",
    address: "",
    displayAddress: "",
    latlng: null,
    bounds: [],
    categories: [],
    accessibility: [],
    tags: [],
    date: null
  },
  tags: {
    loading: false,
    error: false,
    data: null
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_REFINEMENTS:
      return {
        loading: false,
        locationEvents: null,
        error: false,
        searchComponent: {
          query: "",
          address: "",
          displayAddress: "",
          latlng: null,
          categories: [],
          accessibility: [],
          date: null
        }
      };
    case GET_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        locationEvents: null,
        error: false
      };
    case GET_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        locationEvents: action.locationEvents.results
      };
    case GET_SEARCH_ERROR:
      return {
        ...state,
        loading: false,
        error: false
      };

    case SET_REFINEMENTS:
      return {
        ...state,
        searchComponent: {
          ...state.searchComponent,
          ...action.updatedRefinements
        }
      };

    case GET_TAGS_REQUEST:
      return {
        ...state,
        tags: {
          ...state.tags,
          loading: true,
          error: false,
          data: null
        }
      };
    case GET_TAGS_SUCCESS:
      return {
        ...state,
        tags: {
          ...state.tags,
          loading: false,
          error: false,
          data: action.tags
        }
      };
    case GET_TAGS_ERROR:
      return {
        ...state,
        tags: {
          ...state.tags,
          loading: false,
          error: true,
          data: null
        }
      };
    default:
      return state;
  }
};
